module.exports = __webpack_public_path__ + "static/media/tournaments_icon.f470f40a.svg";